import { isAuthorized } from '../../../../../FSM/shared/guards'

const isVerify = (_context: Record<string, string>, event: { isVerify: boolean }) => event.isVerify

export default { isAuthorized, isVerify }
